import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "@Store/store";
import posthog from "posthog-js";
import { PostHogProvider } from 'posthog-js/react'
import { POSTHOG_HOST, POSTHOG_KEY } from "@Constants/config";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

posthog.init(POSTHOG_KEY, {
  api_host: POSTHOG_HOST,
  autocapture: false,
  defaults: '2025-05-24',
});

console.log(posthog.get_distinct_id())

root.render(

  <Provider store={store}>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
